<script>
import { Pie } from "vue-chartjs"

export default {
   extends: Pie,
  name: "PieChart",
  props: ["data"],
  mounted() {    
    let chartData = {
      labels: [],
      datasets: [
        {
          label: "Views by Category",
          data: [],
          backgroundColor: [
            "#bedff0",
            "#6cc7eb",
            "#009ee3",
            "#0077b4",
            "#005075"            
          ]
        }
      ]
    };

    for (let category in this.data) {
      chartData.labels.push(category);
      chartData.datasets[0].data.push(this.data[category]);
    }

    this.renderChart(chartData, {
      responsive: true,
      maintainAspectRatio: false,
      legend:{
        position:'right'       
      } 
    });
  }
};
</script>
